import {RootState} from "../../../store/rootReducer";

export const extraActionsMenuSelector = (state: RootState) => ({
   isMenuOpen: state.review.isExtraActionsMenuOpen,
   cardId: state.review.cardId,
});
